import type { HeaderRowConfig } from '@ztechapps/webui.data-tools'
import { MenuHeaderCell } from '@ztechapps/webui.data-tools'

const ListViewHeader = (props: HeaderRowConfig) => {
  return (
    <>
      <MenuHeaderCell />
      {props._renderDataHeaderCell()}
    </>
  )
}

export { ListViewHeader }
